import { InjectionToken } from '@angular/core';

import { MobileDetection, detectDevice } from '../services/browser-detection';
import { Device, DeviceType } from './browser-detection';

export interface DeviceDetector {
  detectedDevice: Device;
  isMobile: boolean;
  isAndroid: boolean;
  isOS: boolean;
}

export const DEVICE_DETECTOR = new InjectionToken<Readonly<DeviceDetector>>(
  'DeviceDetector'
);

export function DeviceDetectorProvider(): DeviceDetector {
  const detectedDevice = detectDevice(navigator.userAgent);

  return {
    detectedDevice: detectedDevice,
    isMobile: MobileDetection.isMobile(),
    isAndroid: detectedDevice.type === DeviceType.android,
    isOS: detectedDevice.type === DeviceType.ios
  };
}
